import React from "react";
import { useNavigate } from "react-router-dom";
import Button from '../../components/Button';

export default function MenuDisfagia() {
  const navigate = useNavigate();

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Menús adaptados para disfagia</h4>
      </div>

      {/* Menús */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => navigate("/receta/menu-textura-nectar-miel")}>
          Menú textura néctar-miel (sin espesante)
        </Button>

        <Button onClick={() => navigate("/receta/menu-textura-pudin")}>
          Menú textura pudin (sin espesante)
        </Button>
      </div>
    </div>
  );
}